import withTour from "app/with-tour";
import { lazy } from "react";

const NotFoundPage = lazy(() => import("pages/not-found/not-found"));

// login
const LoginPage = lazy(() => import("pages/login/main-page/login"));
const HospitalLoginPage = lazy(
  () => import("pages/login/hospital-login/hospital-login")
);
const ReportErrorPage = lazy(
  () => import("../pages/login/report-error/report-error")
);
const FmeaPage = lazy(() => import("pages/login/fmea/fmea"));
const SurveyPage = lazy(() => import("pages/login/checklist/survey"));
const PublicPage = lazy(() => import("pages/login/public/survey"));

// crm
const CrmPublicPage = lazy(() => import("pages/crm/public/public"));
const CrmPage = lazy(() => import("pages/crm/main-page/crm"));
const CrmDashboardPage = lazy(() => import("pages/crm/dashboard/dashboard"));
const CrmDetailsPage = lazy(() => import("pages/crm/details/details"));
const CrmReferrerPage = lazy(() => import("pages/crm/referrer/referrer"));
const CrmTrackSuggestionsPage = lazy(
  () => import("pages/crm/track-suggestion/track-suggestion")
);
const CrmReferralPage = lazy(() => import("pages/crm/referral/main-page/crm"));
const CrmReferralDetailsPage = lazy(
  () => import("pages/crm/referral/details/details")
);
const CrmReferralReferrerPage = lazy(
  () => import("pages/crm/referral/referrer/referrer")
);

// userpanel checklist
const UserPanelChecklistPage = lazy(
  () => import("pages/user-panel/checklist/main-page/checklist")
);
const UserPanelChecklistChecklistDetailPage = lazy(
  () => import("pages/user-panel/checklist/detail/checklist/details")
);
const UserPanelChecklistInfectionDetailPage = lazy(
  () => import("pages/user-panel/checklist/detail/infection/details")
);
const UserPanelChecklistDashboardChecklistPage = lazy(
  () => import("pages/user-panel/checklist/dashboard/checklist/dashboard")
);
const UserPanelChecklistDashboardInfectionPage = lazy(
  () => import("pages/user-panel/checklist/dashboard/infection/dashboard")
);
const UserPanelChecklistEopPage = lazy(
  () => import("pages/user-panel/checklist/eop/eop")
);
const UserPanelChecklistAnswersChecklistPage = lazy(
  () => import("pages/user-panel/checklist/answers/checklist/main-page/answers")
);
const UserPanelChecklistAnswersInfectionPage = lazy(
  () => import("pages/user-panel/checklist/answers/infection/main-page/answers")
);
const UserPanelChecklistCreateChecklistAnswerPage = lazy(
  () => import("pages/user-panel/checklist/answers/checklist/create/create")
);
const UserPanelChecklistCreateInfectionAnswerPage = lazy(
  () => import("pages/user-panel/checklist/answers/infection/create/create")
);

// userpanel errors
const RecentErrorsPage = lazy(
  () => import("pages/user-panel/errors/recent/recent")
);
const ErrorsWardPage = lazy(
  () => import("pages/user-panel/errors/ward/main-page/ward")
);
const ErrorsWardDashboard = lazy(
  () => import("pages/user-panel/errors/ward/dashboard/dashboard")
);
const ErrorsWardDetailsPage = lazy(
  () => import("pages/user-panel/errors/ward/details/details")
);

// userpanel tickets
const TicketsPage = lazy(
  () => import("pages/user-panel/tickets/main-page/tickets")
);
const CreateTicketPage = lazy(
  () => import("pages/user-panel/tickets/create/create")
);
const TicketDetailsPage = lazy(
  () => import("pages/user-panel/tickets/details/details")
);

// walkround
const WalkroundDashboardPage = lazy(
  () => import("pages/walkround/dashboard/dashboard")
);

// userpanel walkround
const UserPanelWalkroundPage = lazy(
  () => import("pages/user-panel/walkround/main-page/walkround")
);
const WalkroundPdf = lazy(() => import("pages/user-panel/walkround/pdf/pdf"));

// committee
const CommitteeDashboardPage = lazy(
  () => import("pages/committee/dashboard/dashboard")
);

// management
const ErrorsDashboardPage = lazy(
  () => import("pages/errors/dashboard/dashboard")
);

// programs
const ProgramBscPage = lazy(() => import("pages/program/bsc/bsc"));
const ProgramStatusPage = lazy(
  () => import("pages/program/program-status/program-status")
);

// admin panel
const AdminPanelUsers = lazy(() => import("pages/admin-panel/users/users"));

// checklist mehvar
const ChecklistCreatePage = lazy(() => import("pages/checklist/create/create"));
const ChecklistListPage = lazy(() => import("pages/checklist/list/list"));
const ChecklistChecklistDetailPage = lazy(
  () => import("pages/checklist/detail/main-page/checklist/details")
);
const ChecklistAnswersChecklistPage = lazy(
  () => import("pages/checklist/detail/answers/checklist/main-page/answers")
);
const ChecklistDashboardChecklistPage = lazy(
  () => import("pages/checklist/detail/dashboard/checklist/dashboard")
);
const ChecklistDetailEopPage = lazy(
  () => import("pages/checklist/detail/eop/eop")
);
const ChecklistCreateChecklistAnswerPage = lazy(
  () => import("pages/checklist/detail/answers/checklist/create/create")
);
const ChecklistMonitorsPage = lazy(
  () => import("pages/checklist/monitors/monitors")
);

// eop
const EopPage = lazy(() => import("pages/eop/main-page/eop"));
const EopDetailPage = lazy(() => import("pages/eop/detail/detail"));

// education user
const EducationUserMainPage = lazy(
  () => import("pages/education/user/main-page/education")
);
const EducationUserCreateRequest = lazy(
  () => import("pages/education/user/create/create")
);
const EducationUserCalenderPage = lazy(
  () => import("pages/education/user/calender/main-page/calender")
);
const EducationUserMeetingDetailPage = lazy(
  () => import("pages/education/user/calender/detail/detail")
);
const EducationUserCalenderDetailPage = lazy(
  () => import("pages/education/user/calender/calender-detail/calender-detail")
);
const EducationUserExamCreateAnswerPage = lazy(
  () => import("pages/education/user/exam/answers/create/create")
);
const EducationUserExamDetailAnswerPage = lazy(
  () => import("pages/education/user/exam/answers/detail/detail")
);
const EducationUserExamAnswersPage = lazy(
  () => import("pages/education/user/exam/answers/main-page/answers")
);

// education superior
const EducationSuperiorMainPage = lazy(
  () => import("pages/education/superior/main-page/education")
);
const EducationSuperiorRequestsPage = lazy(
  () => import("pages/education/superior/requests/requests")
);
const EducationSuperiorRequestPage = lazy(
  () => import("pages/education/superior/request/request")
);
const EducationSuperiorDashboardPage = lazy(
  () => import("pages/education/superior/dashboard/dashboard")
);
const EducationSuperiorCalenderPage = lazy(
  () => import("pages/education/superior/calender/main-page/calender")
);
const EducationSuperiorMeetingDetailPage = lazy(
  () => import("pages/education/superior/calender/detail/detail")
);
const EducationSuperiorCalenderDetailPage = lazy(
  () =>
    import("pages/education/superior/calender/calender-detail/calender-detail")
);

// education supervisor
const EducationSupervisorMainPage = lazy(
  () => import("pages/education/supervisor/main-page/education")
);
const EducationSupervisorRequestsPage = lazy(
  () => import("pages/education/supervisor/requests/requests")
);
const EducationSupervisorRequestPage = lazy(
  () => import("pages/education/supervisor/request/request")
);
const EducationSupervisorCalenderPage = lazy(
  () => import("pages/education/supervisor/calender/main-page/calender")
);
const EducationSupervisorCalenderDetailPage = lazy(
  () =>
    import(
      "pages/education/supervisor/calender/calender-detail/calender-detail"
    )
);
const EducationSupervisorDashboardPage = lazy(
  () => import("pages/education/supervisor/dashboard/dashboard")
);
const EducationSupervisorCreateMeetingsPage = lazy(
  () => import("pages/education/supervisor/calender/create/create")
);
const EducationSupervisorMeetingDetailPage = lazy(
  () => import("pages/education/supervisor/calender/detail/detail")
);
const EducationSupervisorCoursesPage = lazy(
  () => import("pages/education/supervisor/courses/courses")
);
const EducationSupervisorQuestionBankPage = lazy(
  () =>
    import("pages/education/supervisor/question-bank/main-page/question-bank")
);
const EducationSupervisorCreateQuestionPage = lazy(
  () => import("pages/education/supervisor/question-bank/create/create")
);
const EducationSupervisorChecklistCreatePage = lazy(
  () => import("pages/education/supervisor/checklist/create/create")
);
const EducationSupervisorChecklistListPage = lazy(
  () => import("pages/education/supervisor/checklist/list/list")
);
const EducationSupervisorExamsPage = lazy(
  () => import("pages/education/supervisor/exam/main-page/exam")
);
const EducationSupervisorExamCreatePage = lazy(
  () => import("pages/education/supervisor/exam/create/create")
);
const EducationSupervisorExamSelectQuestionsPage = lazy(
  () =>
    import("pages/education/supervisor/exam/select-questions/select-questions")
);

// indicator
const IndicatorDashboard = lazy(
  () => import("pages/indicator/dashboard/dashboard")
);
const IndicatorBscPage = lazy(() => import("pages/indicator/bsc/bsc"));

export type routesProps = {
  path: string;
  component: React.FC;
  layout?: {
    type?: "core-admin";
    hideFloatingMenu?: boolean;
    showFooter?: boolean;
  };
  authType: "no-auth" | "auth";
  showFooter?: boolean;
  breadCrumbName?: string;
};

const routes: routesProps[] = [
  {
    path: "*",
    component: NotFoundPage,
    authType: "no-auth",
  },
  {
    path: "/nr/login",
    authType: "no-auth",
    layout: {
      hideFloatingMenu: true,
    },
    component: withTour(LoginPage, "login"),
  },
  {
    path: "/nr/login/:id",
    authType: "no-auth",
    layout: {
      showFooter: false,
      hideFloatingMenu: true,
    },
    component: withTour(HospitalLoginPage, "hospitalLogin", 1300),
  },
  {
    path: "/nr/crm/public/:hospitalId",
    authType: "no-auth",
    component: withTour(CrmPublicPage, "publicCrm"),
  },
  {
    path: "/nr/crm",
    authType: "auth",
    component: CrmPage,
  },
  {
    path: "/nr/crm/dashboard",
    authType: "auth",
    component: CrmDashboardPage,
  },
  {
    path: "/nr/crm/track-suggestion",
    authType: "no-auth",
    component: CrmTrackSuggestionsPage,
  },
  {
    path: "/nr/crm/:suggestionId",
    authType: "auth",
    component: CrmDetailsPage,
  },
  {
    path: "/nr/crm/:suggestionId/referrer",
    authType: "auth",
    component: CrmReferrerPage,
  },
  {
    path: "/nr/crm/referral",
    authType: "auth",
    component: CrmReferralPage,
  },
  {
    path: "/nr/crm/referral/:suggestionId",
    authType: "auth",
    component: CrmReferralDetailsPage,
  },
  {
    path: "/nr/crm/referral/:suggestionId/referrer",
    authType: "auth",
    component: CrmReferralReferrerPage,
  },
  {
    path: "/nr/user-panel/checklist",
    authType: "auth",
    component: UserPanelChecklistPage,
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/checklist",
    authType: "auth",
    component: UserPanelChecklistChecklistDetailPage,
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/infection",
    authType: "auth",
    component: UserPanelChecklistInfectionDetailPage,
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/dashboard/checklist",
    authType: "auth",
    component: UserPanelChecklistDashboardChecklistPage,
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/dashboard/infection",
    authType: "auth",
    component: UserPanelChecklistDashboardInfectionPage,
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/eop",
    authType: "auth",
    component: UserPanelChecklistEopPage,
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/checklist/create/:intervalId",
    authType: "auth",
    component: UserPanelChecklistCreateChecklistAnswerPage,
    layout: {
      showFooter: false,
      hideFloatingMenu: true,
    },
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/infection/create/:intervalId",
    authType: "auth",
    component: UserPanelChecklistCreateInfectionAnswerPage,
    layout: {
      showFooter: false,
      hideFloatingMenu: true,
    },
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/answers/:answersId/checklist",
    authType: "auth",
    component: UserPanelChecklistAnswersChecklistPage,
  },
  {
    path: "/nr/user-panel/checklist/:checklistId/answers/infection",
    authType: "auth",
    component: UserPanelChecklistAnswersInfectionPage,
  },
  {
    path: "/nr/committee/dashboard",
    authType: "auth",
    component: withTour(CommitteeDashboardPage, "committeeDashboard"),
  },
  {
    path: "/nr/errors/dashboard",
    authType: "auth",
    component: withTour(ErrorsDashboardPage, "errorsDashboard"),
  },
  {
    path: "/nr/login/error_report/:hospitalId",
    component: ReportErrorPage,
    authType: "no-auth",
  },
  {
    path: "/nr/program/bsc",
    component: ProgramBscPage,
    authType: "auth",
  },
  {
    path: "/nr/program/:status",
    component: ProgramStatusPage,
    authType: "auth",
  },
  {
    path: "/nr/user-panel/errors/recent",
    component: RecentErrorsPage,
    authType: "auth",
  },
  {
    path: "/nr/user-panel/errors/ward",
    component: ErrorsWardPage,
    authType: "auth",
  },
  {
    path: "/nr/user-panel/errors/ward/dashboard",
    component: ErrorsWardDashboard,
    authType: "auth",
  },
  {
    path: "/nr/user-panel/errors/ward/details/:wardId",
    component: ErrorsWardDetailsPage,
    authType: "auth",
  },
  {
    path: "/nr/user-panel/walkround",
    component: UserPanelWalkroundPage,
    authType: "auth",
  },
  {
    path: "/nr/walkround/dashborad",
    component: WalkroundDashboardPage,
    authType: "auth",
  },
  {
    path: "/nr/user-panel/walkround/pdf",
    component: WalkroundPdf,
    authType: "auth",
    layout: {
      showFooter: false,
      hideFloatingMenu: true,
    },
  },
  {
    path: "/nr/user-panel/tickets",
    component: withTour(TicketsPage, "ticketTour"),
    authType: "auth",
  },
  {
    path: "/nr/user-panel/tickets/create",
    component: CreateTicketPage,
    authType: "auth",
  },
  {
    path: "/nr/user-panel/tickets/:ticketId",
    component: TicketDetailsPage,
    authType: "auth",
  },
  {
    path: "/nr/login/checklist/:hospitalId",
    component: withTour(SurveyPage, "surveyTour"),
    authType: "no-auth",
    layout: {
      showFooter: false,
      hideFloatingMenu: true,
    },
  },
  {
    path: "/nr/login/public/:hospitalId",
    component: withTour(PublicPage, "publicTour"),
    authType: "no-auth",
    layout: {
      showFooter: false,
      hideFloatingMenu: true,
    },
  },
  {
    path: "/nr/login/fmea/:hospitalId",
    authType: "no-auth",
    component: FmeaPage,
  },
  {
    path: "/nr/admin-panel/users",
    component: AdminPanelUsers,
    layout: {
      showFooter: false,
    },
    authType: "auth",
    breadCrumbName: "کاربران",
  },
  {
    path: "/nr/checklist/create",
    authType: "auth",
    component: ChecklistCreatePage,
  },
  {
    path: "/nr/checklist/list",
    authType: "auth",
    component: ChecklistListPage,
  },
  {
    path: "/nr/checklist/:checklistId/checklist",
    authType: "auth",
    component: ChecklistChecklistDetailPage,
  },
  {
    path: "/nr/checklist/:checklistId/answers/:answersId/checklist",
    authType: "auth",
    component: ChecklistAnswersChecklistPage,
  },
  {
    path: "/nr/checklist/:checklistId/dashboard/checklist",
    authType: "auth",
    component: ChecklistDashboardChecklistPage,
  },
  {
    path: "/nr/checklist/:checklistId/detail/eop",
    authType: "auth",
    component: ChecklistDetailEopPage,
  },
  {
    path: "/nr/checklist/:checklistId/monitors",
    authType: "auth",
    component: ChecklistMonitorsPage,
  },
  {
    path: "/nr/eop/:eopId",
    authType: "auth",
    component: EopPage,
  },
  {
    path: "/nr/eop/:eopId/detail",
    authType: "auth",
    component: EopDetailPage,
  },
  {
    path: "/nr/checklist/:checklistId/checklist/create/:intervalId",
    authType: "auth",
    component: ChecklistCreateChecklistAnswerPage,
    layout: {
      showFooter: false,
      hideFloatingMenu: true,
    },
  },
  {
    path: "/nr/education/user",
    authType: "auth",
    component: EducationUserMainPage,
  },
  {
    path: "/nr/education/user/create",
    authType: "auth",
    component: EducationUserCreateRequest,
  },
  {
    path: "/nr/education/user/calender",
    authType: "auth",
    component: EducationUserCalenderPage,
  },
  {
    path: "/nr/education/user/calender/:meetingId",
    authType: "auth",
    component: EducationUserMeetingDetailPage,
  },
  {
    path: "/nr/education/user/calender/detail",
    authType: "auth",
    component: EducationUserCalenderDetailPage,
  },
  {
    path: "/nr/education/user/exam/answers/create/:examId",
    authType: "auth",
    component: EducationUserExamCreateAnswerPage,
  },
  {
    path: "/nr/education/user/exam/answers/:examId/detail/:answerId",
    authType: "auth",
    component: EducationUserExamDetailAnswerPage,
  },
  {
    path: "/nr/education/user/exam/answers/:examId",
    authType: "auth",
    component: EducationUserExamAnswersPage,
  },
  {
    path: "/nr/education/superior",
    authType: "auth",
    component: EducationSuperiorMainPage,
  },
  {
    path: "/nr/education/superior/requests",
    authType: "auth",
    component: EducationSuperiorRequestsPage,
  },
  {
    path: "/nr/education/supervisor/requests",
    authType: "auth",
    component: EducationSupervisorRequestsPage,
  },
  {
    path: "/nr/education/superior/request/:userId",
    authType: "auth",
    component: EducationSuperiorRequestPage,
  },
  {
    path: "/nr/education/superior/dashboard",
    authType: "auth",
    component: EducationSuperiorDashboardPage,
  },
  {
    path: "/nr/education/superior/calender",
    authType: "auth",
    component: EducationSuperiorCalenderPage,
  },
  {
    path: "/nr/education/superior/calender/:meetingId",
    authType: "auth",
    component: EducationSuperiorMeetingDetailPage,
  },
  {
    path: "/nr/education/superior/calender/detail",
    authType: "auth",
    component: EducationSuperiorCalenderDetailPage,
  },
  {
    path: "/nr/education/supervisor/request/:userId",
    authType: "auth",
    component: EducationSupervisorRequestPage,
  },
  {
    path: "/nr/education/supervisor",
    authType: "auth",
    component: EducationSupervisorMainPage,
  },
  {
    path: "/nr/education/supervisor/dashboard",
    authType: "auth",
    component: EducationSupervisorDashboardPage,
  },
  {
    path: "/nr/education/supervisor/calender",
    authType: "auth",
    component: EducationSupervisorCalenderPage,
  },
  {
    path: "/nr/education/supervisor/calender/detail",
    authType: "auth",
    component: EducationSupervisorCalenderDetailPage,
  },
  {
    path: "/nr/education/supervisor/calender/create",
    authType: "auth",
    component: EducationSupervisorCreateMeetingsPage,
  },
  {
    path: "/nr/education/supervisor/calender/:meetingId",
    authType: "auth",
    component: EducationSupervisorMeetingDetailPage,
  },
  {
    path: "/nr/education/supervisor/courses",
    authType: "auth",
    component: EducationSupervisorCoursesPage,
  },
  {
    path: "/nr/education/supervisor/question-bank",
    authType: "auth",
    component: EducationSupervisorQuestionBankPage,
  },
  {
    path: "/nr/education/supervisor/question-bank/create",
    authType: "auth",
    component: EducationSupervisorCreateQuestionPage,
  },
  {
    path: "/nr/education/supervisor/checklist/create",
    authType: "auth",
    component: EducationSupervisorChecklistCreatePage,
  },
  {
    path: "/nr/education/supervisor/checklist/list",
    authType: "auth",
    component: EducationSupervisorChecklistListPage,
  },
  {
    path: "/nr/education/supervisor/exam",
    authType: "auth",
    component: EducationSupervisorExamsPage,
  },
  {
    path: "/nr/education/supervisor/exam/create",
    authType: "auth",
    component: EducationSupervisorExamCreatePage,
  },
  {
    path: "/nr/education/supervisor/exam/select-question/:examId",
    authType: "auth",
    component: EducationSupervisorExamSelectQuestionsPage,
  },
  {
    path: "/nr/indicator/dashboard",
    authType: "auth",
    component: IndicatorDashboard,
  },
  {
    path: "/nr/indicator/bsc",
    authType: "auth",
    component: IndicatorBscPage,
  },
];

export default routes;
